// extracted by mini-css-extract-plugin
export var active = "_ri-1";
export var circle = "_ri-0";
export var completed = "_ri-2";
export var connector = "_ri-4";
export var connectorCompleted = "_ri-7";
export var connectorSpacer = "_ri-5";
export var iconStrokeOverride = "_ri-8";
export var labelContainer = "_ri-6";
export var pending = "_ri-3";